import { paths } from '@/routes/paths';

/**
 * Where a student subscription opens: the shared subscription detail route,
 * told which kind of customer the id belongs to.
 */
export function studentSubscriptionPath(id) {
  return `${paths.admin.subscriptionDetail(id)}?customer=student`;
}
